import requestImg from "@src/shared/assets/request.svg";
import detailsRequestImg from "@src/shared/assets/details_request.svg";
import resultsImg from "@src/shared/assets/results.svg";
import vacancyImg from "@src/shared/assets/vacancy.svg";
import vacancyRangImg from "@src/shared/assets/case_1.svg";
import resumeRangImg from "@src/shared/assets/resume_2.svg";
import requestRangImg from "@src/shared/assets/request_3.svg";
import resultsRangImg from "@src/shared/assets/results_4.svg";

export const selectionCandidates = [
  {
    id: 1,
    title: "Вакансия",
    text: "Вставьте описание вакансии. Рекомендуем указать: название вакансии, требования к кандидатуи опыту.",
    img: vacancyImg,
  },
  {
    id: 2,
    title: "Детали запроса",
    text: "Добавьте детали для более точного поиска кандидатов на вашу вакансию. Обязательно укажите специализацию кандидата и необходимые ключевые навыки, дополнительно можно указать: оклад, уровень образования, опыт работы, а также нужный вам регион.",
    img: detailsRequestImg,
  },
  {
    id: 3,
    title: "Запрос",
    text: "Отправьте запрос. Среднее время ожидания результатов - 4-8 мин.",
    img: requestImg,
  },
  {
    id: 4,
    title: "Результаты",
    text: "На странице «Результаты ранжирования» посмотрите статус запроса и детали уже обработанных запросов.",
    img: resultsImg,
  },
];

export const rankingResumes = [
  {
    id: 1,
    title: "Вакансия",
    text: "Вставьте описание вакансии. Рекомендуем указать: название вакансии, требования к кандидату и опыту.",
    img: vacancyRangImg,
  },
  {
    id: 2,
    title: "Резюме",
    text: "Приложите до 30 резюме форматом PDF, DOC, DOCX, RTF, каждый документ должен быть размером не более 10Mb.",
    img: resumeRangImg,
  },
  {
    id: 3,
    title: "Запрос",
    text: "Отправьте запрос. Среднее время ожидания результатов - 1.1,5 мин.",
    img: requestRangImg,
  },
  {
    id: 4,
    title: "Результаты",
    text: "На странице «Результаты ранжирования» посмотрите статус запроса и детали уже обработанных запросов.",
    img: resultsRangImg,
  },
];
